import Modal from 'react-modal'
import { useLang } from '../utils/hooks'
import { langRemove } from '../assets/langRemove'

const RemoveUserModal = ({ options, handleClose, handleDoDelete }) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langRemove.fr : langRemove.eng
  return (
    <Modal
      isOpen={options.remove}
      onRequestClose={handleClose}
      appElement={document.getElementById('root')}
      closeTimeoutMS={300}
      className="modify-modal"
      overlayClassName="modify-modal-overlay"
    >
      <div className="block">
        <label className="label">
          {choosenLang.deleteUserConfirm1}
          <div className="tag is-warning">{options.userName}</div>
          {choosenLang.deleteUserConfirm2}
        </label>
        <br />
        {options.nbSessions > 0 && (
          <table className="table">
            <thead className="has-text-right">
              <tr>
                <th className="has-text-left">
                  <abbr></abbr>
                </th>
                <th>
                  <abbr>No. </abbr>
                </th>
              </tr>
            </thead>
            <tbody className="has-text-right">
              <tr>
                <td className="has-text-left">Sessions</td>
                <td>{options.nbSessions}</td>
              </tr>
              <tr>
                <td className="has-text-left">Boards</td>
                <td>{options.nbBoards}</td>
              </tr>
              <tr>
                <td className="has-text-left">Wings / Sails</td>
                <td>{options.nbSails}</td>
              </tr>
            </tbody>
          </table>
        )}
        <br />
        <div className="block">
          <div className="field is-grouped">
            <div className="control">
              <button
                className="button is-alert"
                data-dismiss="modal"
                onClick={() => handleClose()}
              >
                {choosenLang.cancel}
              </button>
            </div>

            <div className="control">
              <button
                className="button is-danger "
                data-dismiss="modal"
                onClick={() => handleDoDelete()}
              >
                {choosenLang.confirm}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default RemoveUserModal
